import { useEffect, useState } from 'react'
import { useRouteMatch, useHistory, useLocation, Link } from "react-router-dom"
import { LoadingOutlined } from '@ant-design/icons'
import { connect } from 'react-redux'
import { store } from '~/Store'
import { useQuery } from 'Hooks'
import WeaverService from 'Services/WeaverService'
import * as Types from 'Types'
import { ActionsPage, showActionsPage, showCreateMacro, WeaverLoading, ContextMenu } from 'Components'
import { Button, Empty, message, Modal, Tree, Menu } from 'antd'
import Feather from '@sysunite/react-feather'
import { setOpenInConsole, setCurrentItem, setTab, setTabDisabled, setTableConfig } from 'Actions/explore'
import { setExpandedKeys, setNodeData, updateNodeData, setRoots, setTreeData, updateTreeData } from 'Actions/homeTree'
import { getNodeLabel, getProjectData } from 'Services/WeaverUtils'
import TreeNodeFactory, { getRoots } from './TreeNodeFactory'
import { getIcon } from './TreeNodeFactory/shared'
import onSelect from './TreeNodeFactory/onSelect'
import * as model from 'Model'
import tabs from '../tabs'
import './index.scss'

ProjectQueries = ({
  currentBranch,
  currentProject,
  devtoolsEnabled,
  height,
  macros,
  setOpenInConsole,
  setCurrentItem,
  setTab,
  setTabDisabled,
  setTableConfig,
  userMode,
  tabIsLocked,
  roots, setRoots
  treeData, setTreeData, updateTreeData
  nodeData, setNodeData, updateNodeData
  expandedKeys, setExpandedKeys,
  typesMap
}) ->

  [isLoading, setIsLoading] = useState(true)
  [initializing, setInitializing] = useState(true)
  [noProjectSet, setNoProjectSet] = useState(true)
  [loadedKeys, setLoadedKeys] = useState([])

  { url, params: { spaceId }} = useRouteMatch()
  { hash } = useLocation()
  params = useQuery()
  history = useHistory()

  useEffect(->
    ( ->
      if currentProject?
        setNoProjectSet(false)
        setLoadedKeys([])
        generateTreeRoots(currentProject)
      else
        return setInitializing(false)
    )()
    undefined
  , [currentProject, currentBranch, macros])

  generateTreeRoots = ->
    setInitializing(true)
    treeRoots = getRoots(userMode).reduce((acc, cur) ->
      { ...acc, [cur.key]: [] }
    , {})
    nodeDataRoots = getRoots(userMode).reduce((acc, cur) ->
      {
        ...acc,
        [cur.key]: { ...cur }
      }
    , {})
    rootKeys = getRoots(userMode).map(({ key }) -> key)
    setRoots(rootKeys)
    setTreeData(treeRoots)
    setNodeData(nodeDataRoots)
    setInitializing(false)

  getTreeNode = (key, address) ->
    if node = nodeData[address]
      {
        node...
        key: node.path
        icon: getIcon(node.icon or node.type)
        children: buildNodes(treeData[node.path], address)
      }
    else
      {
        key
        title: <LoadingOutlined />
        icon: undefined
      }

  buildNodes = (data = [], parentAddress) ->
    data.map((key) ->
      address = if parentAddress? then "#{parentAddress}/#{key}" else key
      getTreeNode(key, address)
    )

  onLoadData = ({ key, onExpand }) ->
    new Promise((resolve) ->
      if onExpand?
        queryRes = await onExpand({
          history
          spaceId
        })
        updateNodeData({ _.keyBy(queryRes, 'path')... }, 'path')
        updateTreeData({ key, children: queryRes?.map(({ key }) -> key ) or [] })
      setLoadedKeys([loadedKeys..., key])
      resolve()
    )

  if initializing
    <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <WeaverLoading style={{ width: '20%' }} />
    </div>
  else if noProjectSet
    <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Empty description="No project selected" />
    </div>
  else
    <div
      onContextMenu={(e) -> e.preventDefault()}
      className='project-queries-tree'
    >
      <Tree
        data-testid="project-queries-tree"
        expandedKeys={expandedKeys}
        loadedKeys={loadedKeys}
        height={height - 225}
        onExpand={(keys) ->
          localStorage.setItem("#{ currentProject }-queries-expanded-keys", JSON.stringify(keys))
          setExpandedKeys(keys)
        }
        onSelect={(selectedKeys, { node }) ->
          return unless node = nodeData[node?.path]
          onSelect(node, { history, spaceId })
        }
        showIcon={true}
        loadData={onLoadData}
        treeData={buildNodes(roots)}
        style={{ whiteSpace: 'nowrap' }}
      />
    </div>

export default connect(
  ({ branches, explore, homeTree, graph, projects, user }) ->
    {
      currentProject: projects.currentProject
      devtoolsEnabled: graph.devtoolsEnabled
      height: explore.height
      tabIsLocked: explore.tabIsLocked
      typesMap: explore.typesMap
      userMode: user.userMode
      roots: homeTree.roots
      treeData: homeTree.treeData
      nodeData: homeTree.nodeData
      expandedKeys: homeTree.expandedKeys
      currentBranch: branches.currentBranch
      macros: explore.macros
    }
  , {
      setOpenInConsole,
      setCurrentItem,
      setRoots,
      setTab,
      setTabDisabled,
      setTableConfig,
      setTreeData,
      updateTreeData,
      updateNodeData,
      setNodeData,
      setExpandedKeys
    }
)(ProjectQueries)
